import React, {PureComponent, ReactNode} from 'react'

type ButtonProps = {
    title: string
    type?: 'button' | 'submit' | 'reset'
    disabled?: boolean
    className?: string
    outline?: boolean
    onClick: () => void
}

export class Button extends PureComponent<ButtonProps> {

    static defaultProps = {
        disabled: false,
    };

    render(): ReactNode {
        const {title, type, disabled, className, outline, onClick} = this.props
        return (
            <button
                type={type ?? 'button'}
                className={`${className ?? ''}

                        w-full max-w-full md:w-1/3
                        ${outline ? 'bg-transparent border border-neutral-300 text-neutral-700' : 'bg-primary text-white'}
                        rounded-lg
                        mt-4 py-3 px-5
                        text-center font-bold
                        shadow
                        cursor-pointer
                        disabled:opacity-25 disabled:cursor-not-allowed`}
                disabled={disabled}
                onClick={onClick}>
                {title}
            </button>
        )
    }
}
